import React, { useEffect, useState, useCallback } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import LoginStep1 from "./Auth/LoginStep1";
import LoginStep2 from "./Auth/LoginStep2";
import { getCurrentUser } from "../app/store/auth";
import { useLoginMutation } from "../app/store/authApiSlice";

const Login = () => {
  const [validId, setValidId] = useState("");
  const [userPwd, setUserPwd] = useState("");
  const [stateErrors, setStateErrors] = useState("");
  const [step1, setStep1] = useState(true);
  const [step2, setStep2] = useState(false);
  const [isSigningIn, setIsSigningIn] = useState(false);

  const usrType = localStorage.getItem("userType");

  const location = useLocation();
  const navigate = useNavigate();
  const currentUser = getCurrentUser();

  const [login, { isSuccess: isLoginSuccess, isError: isLoginError }] = useLoginMutation();

  useEffect(() => {
    const state = location.state;
    if (state?.validId) {
      setValidId(state.validId);
      setStep1(false);
      setStep2(true);
    }
  }, [location.state]);

  useEffect(() => {
    if (currentUser) {
      navigate("/");
    }
  }, [currentUser, navigate]);

  useEffect(() => {
    if (isLoginSuccess) {
      localStorage.setItem("tempPwd", userPwd);
      setIsSigningIn(false);
      navigate("/ValidateUser");
    }
  }, [isLoginSuccess, navigate, userPwd]);

  useEffect(() => {
    if (isLoginError) {
      setStateErrors("Username or password is incorrect");
      setIsSigningIn(false);
    }
  }, [isLoginError]);

  const handleStep1 = useCallback((step1Data) => {
    if (step1Data?.validId) {
      setStep1(false);
      setStep2(true);
      setValidId(step1Data.validId);
    }
  }, []);

  const doSubmit = useCallback(async (step2Data) => {
    setIsSigningIn(true);
    setUserPwd(step2Data.password);
    const challengeId = localStorage.getItem("challengeId");
    login({
      challengeId,
      username: step2Data.username,
      password: step2Data.password,
    });
  }, [login]);

  const handleBack = useCallback(() => {
    setStep1(true);
    setStep2(false);
    setValidId("");
    localStorage.removeItem("userType");
  }, []);

  const handleForgotPwd = useCallback(() => {
    navigate("/ForgotPassword", { state: { validId } });
  }, [navigate, validId]);

  return (
    <React.Fragment>
      {step1 && (
        <div className="login-page">
          <div className="login-shell">
            {/* <div className="login-top-banner">
              <i className="fa fa-shield" aria-hidden="true"></i>
              <span>Human Resources Information Management System (HRIMS)</span>
            </div> */}
            <section className="login-hero" aria-label="WorkFINITY platform overview">
              <h1>
                Powered by WorkFINITY®
                <br />
                AI Driven Platform
              </h1>
              <div className="login-highlights" aria-label="Portal capabilities">
                <span>Onboarding</span>
                <span>Contracts</span>
                <span>Time Logs</span>
                <span>Invoicing</span>
              </div>
            </section>

            <section className="login-panel" aria-label="Sign in">
              <div className="login-card">
                <div className="login-card-header">
                  <h2>Sign in</h2>
                </div>
                <LoginStep1
                  handleStep1={handleStep1}
                  userError={stateErrors}
                  type="admin"
                ></LoginStep1>
                <div className="mt-3 text-right">
                  <Link to="/ForgotValidID" className="btn btn-link btn-sm login-link p-0" style={{ border: "none", background: "none" }}>
                    Forgot Your ID?
                  </Link>
                </div>
              </div>
            </section>
            <div className="login-saas-banner">
              <i className="fa fa-cloud" aria-hidden="true"></i>
              <span>
                SaaS platform hosted in Microsoft Azure Government Account - a FedRAMP certified cloud infrastructure
              </span>
            </div>
            <div className="login-support-row">
              <a
                className="login-support-link"
                href="mailto:Support@workfinity.com"
                title="Support@workfinity.com"
              >
                <i className="fa fa-life-ring" aria-hidden="true"></i>
                <span>Customer Support</span>
              </a>
            </div>
          </div>
        </div>
      )}

      {step2 && (
        <div className="login-page">
          <div className="login-shell">
            <section className="login-hero" aria-label="Selected account context">
              <div className="login-hero-centered-copy">
                <h1>
                  Powered by WorkFINITY®
                  <br />
                  AI Driven Platform
                </h1>
                <div className="login-highlights" aria-label="Portal capabilities">
                  <span>Onboarding</span>
                  <span>Contracts</span>
                  <span>Time Logs</span>
                  <span>Invoicing</span>
                </div>
              </div>
              <div className="login-hero-account">
                <div>
                  <span>User Type</span>
                  <span><strong>{usrType}</strong></span>
                </div>
                <div>
                  <span>Valid ID</span>
                  <strong>{validId}</strong>
                </div>
              </div>
            </section>

            <section className="login-panel" aria-label="Sign in credentials">
              <div className="login-card">
                <div className="login-card-header">
                  <button className="btn btn-link btn-sm login-back" onClick={handleBack}>
                    <i className="fa fa-arrow-left" aria-hidden="true"></i>
                    Back
                  </button>
                  <h2>Sign in</h2>
                </div>
                <LoginStep2
                  handleDoSubmit={doSubmit}
                  userError={stateErrors}
                  handleForgotPwd={handleForgotPwd}
                  isProcessing={isSigningIn}
                  type="admin"
                ></LoginStep2>
              </div>
            </section>
            <div className="login-saas-banner">
              <i className="fa fa-cloud" aria-hidden="true"></i>
              <span>
                SaaS platform hosted in Microsoft Azure Government Account - a FedRAMP certified cloud infrastructure
              </span>
            </div>
            <div className="login-support-row">
              <a
                className="login-support-link"
                href="mailto:Support@workfinity.com"
                title="Support@workfinity.com"
              >
                <i className="fa fa-life-ring" aria-hidden="true"></i>
                <span>Customer Support</span>
              </a>
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default Login;
